import {useStaticQuery, graphql} from 'gatsby';
export const useSignupPromoData = () => {
	const {sanitySignupPromo} = useStaticQuery(
		graphql`
			query SignupPromoQuery {
				sanitySignupPromo {
					showTimeout
					leftColumnCopy: _rawLeftColumnCopy(
						resolveReferences: {maxDepth: 2}
					)
					centerColumnCopy: _rawCenterColumnCopy(
						resolveReferences: {maxDepth: 2}
					)
					successCopy: _rawSuccessCopy(
						resolveReferences: {maxDepth: 5}
					)
				}
			}
		`,
	);

	return sanitySignupPromo;
};
